import { apiClient } from '../config'

import type { EventLog } from '../types'

type GetEventLogsParams = {
  startDate?: string
  endDate?: string
  limit?: string
  search?: string
}

export const eventLogsService = {
  getAllEventLogs: async (params?: GetEventLogsParams): Promise<EventLog[]> => {
    const response = await apiClient.get<EventLog[]>('/admin/event-logs', {
      params,
    })
    return response.data
  },

  getEventLogsByOrder: async (orderId: string, params?: GetEventLogsParams): Promise<EventLog[]> => {
    const response = await apiClient.get<EventLog[]>(`/admin/event-logs/order/${orderId}`, {
      params,
    })
    return response.data
  },

  getEventLogsByUser: async (userId: string, params?: GetEventLogsParams): Promise<EventLog[]> => {
    const response = await apiClient.get<EventLog[]>(`/admin/event-logs/user/${userId}`, {
      params,
    })
    return response.data
  },
}
